import { z } from "zod";
export const shareLinkKindSchema = z.enum(["generic_intake", "address_request"]);
/** Optional courtesy gate on a collect page. Short, human-shareable. */
export const accessCodeSchema = z.string().min(1).max(64);
export const shareLinkInputSchema = z.discriminatedUnion("kind", [
    z.object({
        kind: z.literal("generic_intake"),
        expiresAt: z.string().datetime().nullable().optional(),
        accessCode: accessCodeSchema.nullable().optional(),
    }),
    z.object({
        kind: z.literal("address_request"),
        contactId: z.string(),
        expiresAt: z.string().datetime().nullable().optional(),
    }),
]);
/**
 * Owner view of the singleton Collect Contacts page. There is exactly one per
 * account; it is published/unpublished rather than created/revoked. `token` is
 * the current public handle (always present so the owner can copy the URL even
 * while paused).
 */
export const collectPageSchema = z.object({
    token: z.string(),
    published: z.boolean(),
    // Plain text so the owner can read it back and share it alongside the link.
    // NEVER returned by public routes.
    accessCode: z.string().nullable(),
    createdAt: z.string(),
});
/** Publish/unpublish and/or set/clear the access code (null clears it). */
export const collectPagePatchSchema = z.object({
    published: z.boolean().optional(),
    accessCode: accessCodeSchema.nullable().optional(),
});
/**
 * Shape returned by the public GET /public/share/:token — drives the form.
 * `status` distinguishes a deliberately paused page (`"disabled"` → show a
 * "sharing turned off" notice) from a live one; missing / revoked / expired
 * tokens are an opaque 404 instead, so token existence still isn't enumerable.
 * `requiresAccessCode` only signals whether a gate exists; the code itself is
 * never exposed publicly.
 */
export const publicShareFormSchema = z.object({
    status: z.enum(["active", "disabled"]),
    kind: shareLinkKindSchema,
    requiresAccessCode: z.boolean(),
    requesterName: z.string().nullable(),
    expiresAt: z.string().nullable(),
});
/** Body for POST /public/share/:token/verify — checks an access code. */
export const verifyAccessCodeBodySchema = z.object({
    accessCode: z.string(),
});
//# sourceMappingURL=shareLink.js.map